import React, {useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {makePostRequest} from '@ibibo/myaccount-reducer';
import {gstOwnerOptions, indianStates} from '../data';
import {editGstFormRow} from '@ibibo/myaccount-reducer';
import {logOmniClick} from '@ibibo/analytics';
import useGstForm from '../../../../../../shared/hooks/useForm';
import {saveTravelGstUrl} from '../../../../../../shared/CommonConfigs/url';
import * as S from './AddGstMobile.styles';
import withFormField from '../../../../../../shared/HOC/withFormField';
import Spinner from '../../../../../../../../onboarding/src/stories/components/OnboardingNew/CommonComponents/Spinner/Spinner';

const InputField = withFormField(S.gstModlInput);

const AddGstMobile = () => {
  const dispatch = useDispatch();
  const gstData = useSelector(editGstFormRow);

  const [isLoading, setIsLoading] = useState(false);
  const [respMessage, setRespMessage] = useState({
    error: '',
    success: '',
  });

  const defaultValues = {
    gstOwner: gstData.gstOwner ? gstData.gstOwner : '',
    gstNumber: gstData.gstNumber ? gstData.gstNumber : '',
    billingAddress: gstData.billingAddress ? gstData.billingAddress : '',
    companyName: gstData.companyName ? gstData.companyName : '',
    state: gstData.state ? gstData.state : '',
    pinCode: gstData.pinCode ? gstData.pinCode : '',
    isDefault: gstData.isDefault ? gstData.isDefault : false,
  };

  const {register, handleSubmit, errors, onSubmit} = useGstForm({defaultValues, onSubmitHandler});

  function onSubmitHandler(data) {
    setIsLoading(true);
    const transformedData = gstData.travellerGstId
      ? {
          ...data,
          travellerGstId: gstData.travellerGstId,
          isDefault: data.isDefault ? 1 : 0,
        }
      : {
          ...data,
          isDefault: data.isDefault ? 1 : 0,
        };
    logOmniClick('mysettings:gst', {
      prop54: `CTA–Save_GST_Clicked `,
    });
    dispatch(
      makePostRequest(
        saveTravelGstUrl,
        {...transformedData},
        () => {
          setIsLoading(false);
          setRespMessage({error: '', success: 'GST details saved successfully'});
          setTimeout(() => {
            window.location.href = '/mysettings';
          }, 2500);
        },
        (resp, data) => {
          setIsLoading(false);
          setRespMessage({error: resp?.error?.errorMessage, success: ''});
        },
      ),
    );
  }

  return (
    <div>
      <S.addGstPageHeader>
        <span className="sprite arrowBackIcon"></span>
        <div>
          <p className="pageHeaderTxt">Add GST Number Details</p>
          <p className="pageHeaderSubTxt">
            Add details of your travel agency's or client’s GST to save them for reuse
          </p>
        </div>
      </S.addGstPageHeader>

      <S.AddGstPageContentWrap>
        <form onSubmit={handleSubmit(onSubmit)}>
          <S.gstModlInputWrap flex="1" margin="0px 0px 0px 10px">
            <p className="inputMdlLabel">GST Owner *</p>
            <InputField
              name="gstOwner"
              register={register}
              errors={errors}
              placeholder="Enter GST Owner"
              type="select"
              options={gstOwnerOptions}
              className={'dropdownClass'}
              {...register('gstOwner', {required: 'GST Owner is required'})}
            />
          </S.gstModlInputWrap>

          <S.gstModlInputWrap flex="1" margin="20px 0px 0px 10px">
            <p className="inputMdlLabel">GST Number *</p>
            <InputField
              name="gstNumber"
              register={register}
              errors={errors}
              width="100%"
              placeholder="Enter GST Number"
              {...register('gstNumber', {required: 'GST Number is required'})}
            />
          </S.gstModlInputWrap>

          <S.gstModlInputWrap flex="1" margin="20px 0px 0px 10px">
            <p className="inputMdlLabel">Billing Address *</p>
            <InputField
              name="billingAddress"
              register={register}
              errors={errors}
              width="100%"
              placeholder="Enter Billing Address"
              {...register('billingAddress', {
                required: 'Billing Address is required',
                maxLength: {
                  value: 200,
                  message: 'Billing Address cannot exceed 200 characters',
                },
              })}
            />
          </S.gstModlInputWrap>

          <S.gstModlInputWrap flex="1" margin="20px 0px 0px 10px">
            <p className="inputMdlLabel">Company Name *</p>
            <InputField
              name="companyName"
              register={register}
              errors={errors}
              width="100%"
              placeholder="Enter Company Name"
              {...register('companyName', {required: 'Company Name is required'})}
            />
          </S.gstModlInputWrap>

          <S.gstModlInputWrap flex="1" margin="20px 0px 0px 10px">
            <p className="inputMdlLabel">State *</p>
            <InputField
              name="state"
              register={register}
              errors={errors}
              placeholder="Enter State"
              type="select"
              className={'dropdownClass'}
              options={indianStates}
              {...register('state', {required: 'State is required'})}
            />
          </S.gstModlInputWrap>

          <S.gstModlInputWrap flex="1" margin="20px 0px 0px 10px">
            <p className="inputMdlLabel">Pin code *</p>
            <InputField
              name="pinCode"
              register={register}
              errors={errors}
              placeholder="Enter Pin Code"
              width="100%"
              {...register('pinCode', {required: 'Pin Code is required'})}
            />
          </S.gstModlInputWrap>

          <div className="makeFlex appendTop">
            <span className="">
              <InputField
                type="checkbox"
                name="isDefault"
                label="Mark as default"
                register={register}
                errors={errors}
                className={'checkboxClass'}
                {...register('isDefault', {})}
              />
            </span>
          </div>

          {!isLoading ? (
            <S.gstModalCtaMob width="100%" backgroundColor="#008cff" color="#FFF" type="submit">
              Save Details
            </S.gstModalCtaMob>
          ) : (
            <S.gstModalCtaLoader>
              <Spinner width="32px" height="32px" />
            </S.gstModalCtaLoader>
          )}
        </form>
        {respMessage.error?.length > 0 && <p className="error">{respMessage.error}</p>}
        {respMessage.success?.length > 0 && <p className="success">{respMessage.success}</p>}
      </S.AddGstPageContentWrap>
    </div>
  );
};

export default AddGstMobile;
